import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import $ from 'jquery';
import { Product, ProductConfig } from '../../models/product';
import { ModalService } from '../../util/modal.service';

@Component({
  selector: 'elastic-table',
  templateUrl: './elasticSearch.component.html',
  styleUrls: ['./elasticSearch.component.scss']
})
export class ElasticSearchComponent implements OnInit, OnChanges {

  @ViewChild('modal', { static: true }) modal: ElementRef<HTMLDivElement> | undefined;
  @Input() products: any;
  @Input() isColaborator: boolean | undefined;
  @Input() isManager: boolean | undefined;
  @Input() subsidiary: any;
  @Input() actualSearch: any;
  @Input() selectedProduct: Product | undefined
  isVisible = false;

  openCoverages = false;
  indexSelectedCoverage = 1;

  constructor( public _route: Router,
               public _modalService: ModalService,
  ){}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    this.products.forEach((prod: { isExpanded: boolean; }) => {
      prod.isExpanded = false;
    });
  }

  selectItemCoverages(index: number) {
    //this.openCoverages = this.openCoverages && this.indexSelectedCoverage === index ? false : true;
    //this.indexSelectedCoverage = index;
  }

  listConfig(el: HTMLElement) {
    $(el).children('.box').toggleClass('d-none');
  }

  selectConf(el: HTMLElement, conf: ProductConfig) {
    // @ts-ignore
    $(el).parent().parent().prev().html('S/ ' + conf.price.toString())
    // @ts-ignore
    $(el).parent().parent().next().html(conf.unitAvailable.toString())
  }

  editar(product: Product) {
    this._route.navigate(['/members/product/detailProduct', product.productId])
  }

  eliminar(product: Product) {
    this.selectedProduct = product
    $('table .box').addClass('d-none')
     // @ts-ignore
    this.modal.nativeElement.classList.remove('d-none')
  }

  toggleOptions(e: HTMLImageElement) {
     // @ts-ignore
    let div: HTMLElement = e.parentElement
    if (div.classList.contains('options')) {
       // @ts-ignore
      div.querySelector('.box').classList.toggle('d-none')
    }
  }

}
